import { mapState } from 'vuex'
import ClientContractCard from '@/components/client/contract/card/ClientContractCard.vue'
import SummaryPlacedSimple from '@/components/reports/summaryplacedsimple/SummaryPlacedSimple.vue'

export default {
  name: 'ClientListExpand',
  props: {
    data: Object
  },
  components: {
    ClientContractCard,
    SummaryPlacedSimple
  },
  computed: {
    ...mapState(['config']),
    enabledContracts () {
      if (this.data && this.data.active_contracts) {
        return this.data.active_contracts.filter(el => !el.disabled);
      }
      return [];
    },
    clientTotalBalance () {
      return parseFloat(this.data.balance) + parseFloat(this.data.balanceAdvanceBill) + parseFloat(this.data.balanceOpenOrders);
    }
  },
  methods: {
    simulateUser (el, approved = false) {
      if (approved) {
        this.ApiRequest.simulateUser(el, this);
      } else {
        this.$refs.userSimulateMsgBox.show(el, this.$t('user.simulate.title'), this.$t('user.simulate.message', { userName: el.name, email: el.email }))
      }
    }
  }
}
